// extracted by mini-css-extract-plugin
export var editButton = "_ou-0";